import { gql } from '@apollo/client';
import { camelCase } from 'lodash';

import {
    GET_BUSINESS_CENTRAL_INTEGRATIONS,
    GET_MICROTECH_BUERO_PLUS_INTEGRATIONS,
    GET_NETSUITE_INTEGRATIONS,
    GET_QUICKBOOKS_INTEGRATIONS,
    GET_SAGE100_INTEGRATIONS,
    GET_SAP_BUSINESS_ONE_INTEGRATIONS,
    GET_WECLAPP_INTEGRATIONS,
} from '../../../../customer/queries.ts';

export const MASTER_DATA_TOOL_PROVIDER_KEY = 'MASTER_DATA_TOOL_PROVIDER';
export const ORDER_HISTORY_TOOL_PROVIDER_KEY = 'ORDER_HISTORY_TOOL_PROVIDER';

// Every tool provider that is not one of the two Workist-internal ones connects an ERP.
export const isErpToolProvider = (key: string) =>
    key !== MASTER_DATA_TOOL_PROVIDER_KEY && key !== ORDER_HISTORY_TOOL_PROVIDER_KEY;

// Which query lists a provider's configured connections, and under which key the result carries them.
export const ERP_TOOL_PROVIDER_QUERIES = {
    BUSINESS_CENTRAL_TOOL_PROVIDER: GET_BUSINESS_CENTRAL_INTEGRATIONS,
    NETSUITE_ERP_TOOL_PROVIDER: GET_NETSUITE_INTEGRATIONS,
    GET_SAP_BUSINESS_ONE_ERP_TOOL_PROVIDER: GET_SAP_BUSINESS_ONE_INTEGRATIONS,
    QUICKBOOKS_ERP_TOOL_PROVIDER: GET_QUICKBOOKS_INTEGRATIONS,
    WECLAPP_ERP_TOOL_PROVIDER: GET_WECLAPP_INTEGRATIONS,
    SAGE_100_ERP_TOOL_PROVIDER: GET_SAGE100_INTEGRATIONS,
    MICROTECH_BUERO_PLUS_ERP_TOOL_PROVIDER: GET_MICROTECH_BUERO_PLUS_INTEGRATIONS,
};

export const ERP_TOOL_PROVIDER_QUERY_KEYS = {
    BUSINESS_CENTRAL_TOOL_PROVIDER: 'businessCentralIntegrations',
    NETSUITE_ERP_TOOL_PROVIDER: 'netsuiteIntegrations',
    GET_SAP_BUSINESS_ONE_ERP_TOOL_PROVIDER: 'sapBusinessOneIntegrations',
    QUICKBOOKS_ERP_TOOL_PROVIDER: 'quickBooksIntegrations',
    WECLAPP_ERP_TOOL_PROVIDER: 'weclappIntegrations',
    SAGE_100_ERP_TOOL_PROVIDER: 'sage100Integrations',
    MICROTECH_BUERO_PLUS_ERP_TOOL_PROVIDER: 'microtechBueroPlusIntegrations',
};

export const ERP_TOOL_PROVIDER_IMAGES = {
    BUSINESS_CENTRAL_TOOL_PROVIDER: '/images/external_logos/business-central.png',
    DEMO_ERP_TOOL_PROVIDER: '/images/external_logos/demo-erp.png',
    NETSUITE_ERP_TOOL_PROVIDER: '/images/external_logos/netsuite.png',
    QUICKBOOKS_ERP_TOOL_PROVIDER: '/images/external_logos/quickbooks.png',
    SAGE_100_ERP_TOOL_PROVIDER: '/images/external_logos/Sage_Logo_Black_RGB png.webp',
    MICROTECH_BUERO_PLUS_ERP_TOOL_PROVIDER: '/images/external_logos/microtech.png',
    SAP_BUSINESS_ONE_ERP_TOOL_PROVIDER: '/images/external_logos/sap_business_one.png',
    WECLAPP_ERP_TOOL_PROVIDER: '/images/external_logos/weclapp-vertical-positive.png',
};

// The `toolProviders.*` key (agents namespace) a provider's name and description live under.
export const erpToolProviderTranslationKey = (key: string) => camelCase(key || '').replace('ToolProvider', '');

// useQuery needs a document even while it is skipped; the picked provider's own query replaces it.
export const NO_INTEGRATIONS_QUERY = gql`
    query NoIntegrations {
        __typename
    }
`;
